import { useQuery } from '@tanstack/react-query';

import { getGoogleApiKey } from '@/utils';

const useAddressSuggestions = ({ addressQuery }: { addressQuery: string }) => {
  const queryKey = ['address-suggestions', addressQuery];

  const googleMapsApiKey = getGoogleApiKey(
    process.env.NEXT_PUBLIC_GOOGLE_MAP_API,
  );

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      const request = {
        input: addressQuery,
        includedRegionCodes: ['us'],
      };

      const response = await fetch(
        'https://places.googleapis.com/v1/places:autocomplete',
        {
          method: 'POST',
          body: JSON.stringify(request),
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': googleMapsApiKey,
          },
        },
      );

      const { suggestions } = await response.json().catch(() => {});

      return { suggestions };
    },
    enabled: !!addressQuery,
  });

  return {
    suggestions: (data?.suggestions ??
      []) as google.maps.places.AutocompleteSuggestion[],
    isLoading,
  };
};

export { useAddressSuggestions };
